import React, { useEffect, useState } from "react";
import NavigationBar from "../NavigationBar";
import SideNavigation from "../SideNavigation";
import {
  Alert,
  Button,
  Col,
  Form,
  Table,
  CardColumns,
  Card,
  Row,
} from "react-bootstrap";
import { useFormik } from "formik";
import * as yup from "yup";
import "../../styles/css/ConnectionForm.css";
import micro_reporter_api from "../../apis/micro-reporter-api";
import save from "../../assets/img/save.png";
import $ from "jquery";
import Utils from "../../libraries/utils";

const ConnectionSettingForm = () => {
  const [showReportNameErrorMessage, setShowReportNameErrorMessage] =
    useState(false);
  const [showQueryErrorMessage, setShowQueryErrorMessage] = useState(false);
  const [showUnauthorizedErrorMessage, setShowUnauthorizedErrorMessage] =
    useState(false);
  const [
    showSourceContainsCommentErrorMessage,
    setShowSourceContainsCommentErrorMessage,
  ] = useState(false);
  const [
    showSourceContainsSemicolonErrorMessage,
    setShowSourceContainsSemicolonErrorMessage,
  ] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  let reportNameErrorMessage = "This report name is already in use!";
  let queryErrorMessage = "Query is wrong!";
  let unauthorizedErrorMessage = "You are not authorized to do this operation.";
  let sourceContainsCommentErrorMessage = "Source can not contains comment.";
  let sourceContainsSemicolonErrorMessage =
    "Source can not contains semicolon.";
  let errorMessage = "An unexpected error was encountered!";

  const [columns, setColumns] = useState([]);
  const [fieldTypes, setFieldTypes] = useState([]);
  const [connections, setConnections] = useState([]);
  const [reportUsers, setReportUsers] = useState([]);
  const [initDefName, setInitDefName] = useState("");
  const [dbType, setDbType] = useState("");
  const [projects, setProjects] = useState([]);
  const [completed, setCompleted] = useState(false);

  let initialValues = { defName: "", defConn: "" };

  useEffect(() => {
    getFieldTypes();
    getProjects();
    preUpdate();
    getConnections(
      new URLSearchParams(window.location.search).get("projectId")
    );
  }, []);

  $(document).ready(function () {
    if (connections.length > 0) {
      let a = connections.find(
        (x) =>
          x.id === Number(document.getElementById("connections-combobox").value)
      );
      setDbType(a.databaseProvider.providerName);
    } else setDbType("");
  });

  const preUpdate = () => {
    let id = new URLSearchParams(window.location.search).get("id");
    let clone = new URLSearchParams(window.location.search).get("clone");
    if (id != null && !clone) {
      getReportData(id);
    } else if (id != null && clone) {
      getReportDataForClone(id);
    }
  };

  const setInitialValues = (data) => {
    initialValues.defName = data.name;
    setInitDefName(data.name);
    document.getElementById("defConn").value = data.source;
  };

  const getReportData = (id, setValues = true) => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        const response = await micro_reporter_api.get(
          `/micro-reporter/report/get-update-data?id=${id}`
        );
        if (setValues) {
          setInitialValues(response.data);
          setColumns(setFieldsForUpdate(response.data.fields));
          setFieldTypesForUpdate(response.data.fields);
        }
        setReportUsers(response.data.reportUsers);
        setUserPreferences(response.data.reportUsers);
        Utils.loadingScreen("hide");
      })();
    } catch {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const getReportDataForClone = (id) => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        const response = await micro_reporter_api.get(
          `/micro-reporter/report/get-update-data?id=${id}`
        );
        setInitialValues(response.data);
        Utils.loadingScreen("hide");
      })();
    } catch {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const setUserPreferences = (reportUsers) => {
    reportUsers.map((reportUser) => {
      if (reportUser.canView) {
        document.getElementById(reportUser.user.id + "-canView").checked = true;
      }
      if (reportUser.canExport) {
        document.getElementById(
          reportUser.user.id + "-canExport"
        ).checked = true;
      }
    });
  };

  const setFieldsForUpdate = (fields) => {
    let list = [];
    fields.map((field) => {
      list.push(field.name);
    });
    return list;
  };

  const setFieldTypesForUpdate = (fields) => {
    fields.map((field) => {
      document.getElementById(field.name + "-cihanca-combobox").selectedIndex =
        Number(field.fieldType.typeCode) - 100;
    });
  };

  const getFieldTypes = () => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        const response = await micro_reporter_api.get(
          "/micro-reporter/field-type/all"
        );
        setFieldTypes(response.data);
        Utils.loadingScreen("hide");
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const getConnections = (projectId) => {
    if (projectId !== null) {
      try {
        Utils.loadingScreen("show");
        (async () => {
          const response = await micro_reporter_api.get(
            `/micro-reporter/database/find-by-project-id?projectId=${projectId}`
          );
          setConnections(response.data);
          Utils.loadingScreen("hide");
        })();
      } catch (e) {
        Utils.loadingScreen("hide");
      } finally {
        Utils.loadingScreen("hide");
      }
    }
  };

  const getProjects = () => {
    setCompleted(false);
    try {
      Utils.loadingScreen("show");
      (async () => {
        const response = await micro_reporter_api.get(
          `/micro-reporter/project/all`
        );
        setProjects(response.data);
        setCompleted(true);
        Utils.loadingScreen("hide");
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const getUsers = () => {
    try {
      Utils.loadingScreen("show");
      (async () => {
        await micro_reporter_api
          .get(`/micro-reporter/user/all-users-order-role`)
          .then((response) => {
            let logged = JSON.parse(localStorage.getItem("user"));
            let users = [];
            response.data.map((item) => {
              users.push({
                user: item,
                canView: item.id === logged.id ? true : false,
                canExport: item.id === logged.id ? true : false,
              });
            });
            users.sort(function (x, y) {
              return x.canView == true ? -1 : y.canView == true ? 1 : 0;
            });
            setReportUsers(users);
            Utils.loadingScreen("hide");
          });
      })();
    } catch (e) {
      Utils.loadingScreen("hide");
    } finally {
      Utils.loadingScreen("hide");
    }
  };

  const getColumns = () => {
    closeAll();
    let query = document.getElementById("defConn").value;

    if (query.includes(";")) {
      showSourceContainsSemicolonError();
      return;
    }

    const request = {
      query,
      dcId: document.getElementById("connections-combobox").value,
    };
    (async () => {
      try {
        Utils.loadingScreen("show");
        await micro_reporter_api
          .post("/micro-reporter/report/column-metadata", request)
          .then((response) => {
            setColumns(response.data);
            Utils.loadingScreen("hide");
            let id = new URLSearchParams(window.location.search).get("id");
            id ? getReportData(id, false) : getUsers();
          });
      } catch (err) {
        Utils.loadingScreen("hide");
        try {
          showFailMessages(err.response);
        } catch (err) {
          showError();
        }
      }
    })();
  };

  const getFields = () => {
    let list = [];
    columns.map((column) => {
      let o = {
        name: column,
        fieldType: {
          id: document.getElementById(column + "-cihanca-combobox").value,
        },
      };
      list.push(o);
    });
    return list;
  };

  const getUserPreferences = () => {
    let list = [];
    reportUsers.map((reportUser) => {
      if (
        document.getElementById(reportUser.user.id + "-canView").checked ||
        document.getElementById(reportUser.user.id + "-canExport").checked
      ) {
        let o = {
          user: { id: reportUser.user.id },
          canView: document.getElementById(reportUser.user.id + "-canView")
            .checked,
          canExport: document.getElementById(reportUser.user.id + "-canExport")
            .checked,
        };
        list.push(o);
      }
    });
    return list;
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: yup.object({
      defName: yup.string().required("Definition Name can not be blank."),
    }),
    onSubmit: (values) => {
      closeAll();
      let id = new URLSearchParams(window.location.search).get("id");
      let clone = new URLSearchParams(window.location.search).get("clone");
      values["defConn"] = document.getElementById("defConn").value;
      values["status"] = true;
      if (id === null) {
        saveReport(values);
      } else if (clone) {
        saveReport(values);
      } else {
        values["id"] = id;
        updateReport(values);
      }
    },
  });

  const trimValues = (values) => {
    let temp = values;
    for (const [key, value] of Object.entries(temp)) {
      try {
        temp[key] = value.trim();
      } catch (e) {
        temp[key] = value;
      }
    }
    return temp;
  };

  const saveReport = (values) => {
    (async () => {
      values = trimValues(values);
      let reportDTO = {
        name: values.defName,
        source: values.defConn,
        databaseConnection: {
          id: document.getElementById("connections-combobox").value,
        },
        reportUsers: getUserPreferences(),
        status: values.status,
      };
      let fieldDTOList = getFields();
      let dto = { reportDTO: reportDTO, fieldDTOList: fieldDTOList };
      try {
        Utils.loadingScreen("show");
        let user = JSON.parse(localStorage.getItem("user"));
        let headers = {
          userId: user.id,
          username: user.username,
          relatedName: encodeURIComponent(values.defName),
        };
        dto["userId"] = user.id;
        const config = { headers };
        await micro_reporter_api
          .post("/micro-reporter/report/save", dto, config)
          .then((response) => {
            window.location.href = createWindowLocationHref();
            Utils.loadingScreen("hide");
          });
      } catch (err) {
        Utils.loadingScreen("hide");
        try {
          showFailMessages(err.response);
        } catch (err) {
          showError();
        }
      }
    })();
  };

  const updateReport = (values) => {
    (async () => {
      values = trimValues(values);
      let reportDTO = {
        id: values.id,
        name: values.defName,
        source: values.defConn,
        databaseConnection: {
          id: document.getElementById("connections-combobox").value,
        },
        reportUsers: getUserPreferences(),
        status: values.status,
      };
      let fieldDTOList = getFields();
      let dto = { reportDTO: reportDTO, fieldDTOList: fieldDTOList };
      try {
        Utils.loadingScreen("show");
        let user = JSON.parse(localStorage.getItem("user"));
        let headers = {
          userId: user.id,
          username: user.username,
          relatedName: encodeURIComponent(initDefName),
          relatedId: values.id,
        };
        dto["userId"] = user.id;
        const config = { headers };
        await micro_reporter_api
          .post("/micro-reporter/report/update", dto, config)
          .then((response) => {
            window.location.href = createWindowLocationHref();
            Utils.loadingScreen("hide");
          });
      } catch (err) {
        Utils.loadingScreen("hide");
        try {
          showFailMessages(err.response);
        } catch (err) {
          showError();
        }
      }
    })();
  };

  const createWindowLocationHref = () => {
    let did = document.getElementById("connections-combobox").value;
    let pid = document.getElementById("projects-combobox").value;

    let projectId = new URLSearchParams(window.location.search).get(
      "projectId"
    );
    let dcid = new URLSearchParams(window.location.search).get("dcid");

    let query = "/reports";
    if (projectId) {
      query += "?projectId=" + pid;
    }
    if (projectId && dcid) {
      query += "&dcid=" + did;
    } else if (dcid) {
      query += "?dcid=" + did;
    }
    return query;
  };

  const showFailMessages = (response) => {
    switch (response.status) {
      case 400:
        showQueryError();
        break;
      case 401:
        showUnauthorizedError();
        break;
      case 406:
        showReportNameError();
        break;
      case 409:
        showSourceContainsCommentError();
        break;
      default:
        showError();
    }
  };

  const showReportNameError = () => {
    setShowReportNameErrorMessage(true);
    setShowQueryErrorMessage(false);
    setShowUnauthorizedErrorMessage(false);
    setShowErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(false);
    setShowSourceContainsSemicolonErrorMessage(false);
  };

  const showQueryError = () => {
    setShowQueryErrorMessage(true);
    setShowReportNameErrorMessage(false);
    setShowUnauthorizedErrorMessage(false);
    setShowErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(false);
    setShowSourceContainsSemicolonErrorMessage(false);
  };

  const showUnauthorizedError = () => {
    setShowUnauthorizedErrorMessage(true);
    setShowQueryErrorMessage(false);
    setShowReportNameErrorMessage(false);
    setShowErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(false);
    setShowSourceContainsSemicolonErrorMessage(false);
  };

  const showError = () => {
    setShowErrorMessage(true);
    setShowQueryErrorMessage(false);
    setShowUnauthorizedErrorMessage(false);
    setShowReportNameErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(false);
    setShowSourceContainsSemicolonErrorMessage(false);
  };

  const showSourceContainsCommentError = () => {
    setShowErrorMessage(false);
    setShowQueryErrorMessage(false);
    setShowUnauthorizedErrorMessage(false);
    setShowReportNameErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(true);
    setShowSourceContainsSemicolonErrorMessage(false);
  };

  const showSourceContainsSemicolonError = () => {
    setShowErrorMessage(false);
    setShowQueryErrorMessage(false);
    setShowUnauthorizedErrorMessage(false);
    setShowReportNameErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(false);
    setShowSourceContainsSemicolonErrorMessage(true);
  };

  const closeAll = () => {
    setShowErrorMessage(false);
    setShowQueryErrorMessage(false);
    setShowUnauthorizedErrorMessage(false);
    setShowReportNameErrorMessage(false);
    setShowSourceContainsCommentErrorMessage(false);
    setShowSourceContainsSemicolonErrorMessage(false);
  };

  const renderFetchedPreferences = () => {
    return (
      <div style={{ margin: "0 30px 2px 90px" }}>
        {renderColumnPreferencesDiv()}
        {renderUserPreferences()}
      </div>
    );
  };

  const renderColumnPreferencesDiv = () => {
    if (columns.length > 0) {
      return (
        <div className="col-md-12" id="connection-form-page-fields-div">
          <h6 style={{ fontWeight: "600", marginBottom: "20px" }}>Fields</h6>
          <Row xs={1} md={3} className="g-4">
            {renderColumnPreferences(columns)}
          </Row>
        </div>
      );
    }
  };

  const toggleAllCanView = () => {
    if (reportUsers.length > 0) {
      if (document.getElementById("all-canView").checked) {
        reportUsers.map((reportUser) => {
          document.getElementById(
            reportUser.user.id + "-canView"
          ).checked = true;
        });
      } else {
        reportUsers.map((reportUser) => {
          document.getElementById(
            reportUser.user.id + "-canView"
          ).checked = false;
          document.getElementById(
            reportUser.user.id + "-canExport"
          ).checked = false;
        });
        document.getElementById("all-canExport").checked = false;
      }
    }
  };

  const toggleAllCanExport = () => {
    if (reportUsers.length > 0) {
      if (document.getElementById("all-canExport").checked) {
        reportUsers.map((reportUser) => {
          document.getElementById(
            reportUser.user.id + "-canExport"
          ).checked = true;
        });
      } else {
        reportUsers.map((reportUser) => {
          document.getElementById(
            reportUser.user.id + "-canExport"
          ).checked = false;
        });
      }
    }
  };

  const renderUserPreferences = () => {
    if (columns.length > 0 && reportUsers.length > 0) {
      return (
        <div className="col-md-12" id="connection-form-page-user-div">
          <div>
            <h6 style={{ fontWeight: "600", marginBottom: "20px" }}>
              User Permissions
            </h6>
            <Form.Row
              style={{ position: "absolute", top: "18px", right: "30px" }}
            >
              <Form.Group id="formGridCheckbox" style={{ marginRight: "15px" }}>
                <Form.Check
                  type="checkbox"
                  id={"all-canView"}
                  label="all can view"
                  custom
                  onClick={() => toggleAllCanView()}
                />
              </Form.Group>
              <Form.Group id="formGridCheckbox">
                <Form.Check
                  type="checkbox"
                  id={"all-canExport"}
                  label="all can export"
                  custom
                  onClick={() => toggleAllCanExport()}
                />
              </Form.Group>
            </Form.Row>
          </div>
          <Row xs={1} md={3} className="g-4">
            {renderUserColumns()}
          </Row>
          {renderSaveButton()}
        </div>
      );
    }
  };

  const renderColumnPreferences = (columns) => {
    return columns.map((column) => {
      return (
        <Col>
          <Card bg="light" className="mb-4" style={{ overflow: "hidden" }}>
            <Card.Body>
              <Card.Title style={{ fontSize: "15px", display: "inline-flex" }}>
                {column}
              </Card.Title>
              <Form.Control as="select" id={column + "-cihanca-combobox"}>
                {renderSelectOptions(column)}
              </Form.Control>
            </Card.Body>
          </Card>
        </Col>
      );
    });
  };

  const renderSelectOptions = (column) => {
    return fieldTypes.map((fieldType) => {
      return (
        <option key={column + "-cihanca-" + fieldType.id} value={fieldType.id}>
          {fieldType.typeName}
        </option>
      );
    });
  };

  const renderQueryText = () => {
    return `Enter Query (${dbType})`;
  };

  const renderTextArea = () => {
    return (
      <div>
        <Form.Row>
          <Form.Group as={Col} md="6">
            <Form.Label>{renderQueryText()}</Form.Label>
            <Form.Control
              as="textarea"
              name="defConn"
              placeholder=""
              onChange={() => setColumns([])}
              id="defConn"
            />
            {showQueryErrorMessage ? (
              <div
                style={{
                  fontFamily: "Lexend Deca",
                  fontSize: "12px",
                  color: "#ff0000",
                }}
              >
                {queryErrorMessage}
              </div>
            ) : null}
            {showUnauthorizedErrorMessage ? (
              <div
                style={{
                  fontFamily: "Lexend Deca",
                  fontSize: "12px",
                  color: "#ff0000",
                }}
              >
                {unauthorizedErrorMessage}
              </div>
            ) : null}
            {showSourceContainsCommentErrorMessage ? (
              <div
                style={{
                  fontFamily: "Lexend Deca",
                  fontSize: "12px",
                  color: "#ff0000",
                }}
              >
                {sourceContainsCommentErrorMessage}
              </div>
            ) : null}
            {showSourceContainsSemicolonErrorMessage ? (
              <div
                style={{
                  fontFamily: "Lexend Deca",
                  fontSize: "12px",
                  color: "#ff0000",
                }}
              >
                {sourceContainsSemicolonErrorMessage}
              </div>
            ) : null}
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} md="6">
            {renderFetchButton()}
          </Form.Group>
        </Form.Row>
      </div>
    );
  };

  const renderConnectionBoxOptions = () => {
    return connections.map((connection) => {
      return (
        <option
          selected={
            Number(new URLSearchParams(window.location.search).get("dcid")) ===
            connection.id
              ? "selected"
              : ""
          }
          key={connection.databaseConnectionName + "-cihanca-" + connection.id}
          value={connection.id}
        >
          {connection.databaseConnectionName}
        </option>
      );
    });
  };

  const renderConnectionBox = () => {
    return (
      <Form.Control
        as="select"
        id={"connections-combobox"}
        onChange={(event) => onChangeConnectionBox(event)}
      >
        {renderConnectionBoxOptions()}
      </Form.Control>
    );
  };

  const renderProjectBoxOptions = () => {
    return projects.map((project) => {
      return (
        <option
          selected={
            Number(
              new URLSearchParams(window.location.search).get("projectId")
            ) === project.project.id
              ? "selected"
              : ""
          }
          key={project.project.id}
          value={project.project.id}
        >
          {project.project.name}
        </option>
      );
    });
  };

  // onChange={(event)=> onChangeConnectionBox(event)}
  const renderProjectBox = () => {
    return (
      <Form.Control
        as="select"
        id={"projects-combobox"}
        onChange={(event) => onChangeProjectBox(event)}
      >
        <option value={undefined} disabled selected="selected">
          Select Project
        </option>
        {renderProjectBoxOptions()}
      </Form.Control>
    );
  };

  const onChangeConnectionBox = (event) => {
    let a = connections.find((x) => x.id === Number(event.target.value));
    setDbType(a.databaseProvider.providerName);
    setColumns([]);
  };

  const onChangeProjectBox = (event) => {
    getConnections(Number(event.target.value));
    setColumns([]);
  };

  const toggleCheckboxView = (id) => {
    if (document.getElementById(id + "-canView")) {
      document.getElementById(id + "-canExport").checked = false;
    }
  };

  const toggleCheckboxExport = (id) => {
    if (!document.getElementById(id + "-canView").checked) {
      document.getElementById(id + "-canExport").checked = false;
    }
  };

  const renderUserColumns = () => {
    let logged = JSON.parse(localStorage.getItem("user"));
    if (reportUsers.length > 0) {
      return reportUsers.map((reportUser) => {
        return (
          <Col>
            <Card bg="light" className="mb-4" style={{ overflow: "hidden" }}>
              <Card.Body style={{ paddingBottom: "0" }}>
                <Card.Title
                  title={reportUser.user.name + " " + reportUser.user.surname}
                  style={{ fontSize: "15px", display: "block ruby" }}
                >
                  {reportUser.user.name} {reportUser.user.surname}
                </Card.Title>
                <Form.Row style={{ paddingLeft: "5px" }}>
                  <Form.Group
                    id="formGridCheckbox"
                    style={{ marginRight: "25px" }}
                  >
                    <Form.Check
                      type="checkbox"
                      id={reportUser.user.id + "-canView"}
                      label="can view"
                      custom
                      defaultChecked={
                        reportUser.user.id === logged.id ? true : false
                      }
                      onClick={() => toggleCheckboxView(reportUser.user.id)}
                    />
                  </Form.Group>
                  <Form.Group id="formGridCheckbox">
                    <Form.Check
                      type="checkbox"
                      id={reportUser.user.id + "-canExport"}
                      label="can export"
                      custom
                      defaultChecked={
                        reportUser.user.id === logged.id ? true : false
                      }
                      onClick={() => toggleCheckboxExport(reportUser.user.id)}
                    />
                  </Form.Group>
                </Form.Row>
              </Card.Body>
            </Card>
          </Col>
        );
      });
    }
  };

  const renderDatabaseConnectionError = () => {
    if (
      document.getElementById("projects-combobox") &&
      document.getElementById("projects-combobox").selectedIndex !== 0 &&
      projects.length > 0 &&
      connections.length === 0
    ) {
      return (
        <div
          style={{
            fontFamily: "Lexend Deca",
            fontSize: "12px",
            color: "#ff0000",
          }}
        >
          No database connections found of this project, create a connection
          before creating the report.
        </div>
      );
    }
  };

  const renderProjectError = () => {
    if (completed && projects.length === 0) {
      return (
        <div
          style={{
            fontFamily: "Lexend Deca",
            fontSize: "12px",
            color: "#ff0000",
          }}
        >
          No project found, create a project before creating the report.
        </div>
      );
    }
  };

  const renderSaveButton = () => {
    if (columns.length > 0 && reportUsers.length > 0) {
      return (
        <div style={{ marginTop: "20px" }}>
          <Button
            type="submit"
            onClick={() => formik.submitForm()}
            style={{ float: "right", width: "150px", marginLeft: "10px" }}
          >
            Save
          </Button>
        </div>
      );
    }
  };

  const renderFetchButton = () => {
    return (
      <Button
        onClick={() => getColumns()}
        style={{ float: "right", width: "150px" }}
        disabled={connections.length === 0 ? "disabled" : ""}
      >
        Fetch Fields
      </Button>
    );
  };

  return (
    <div>
      <SideNavigation current="reports" />
      <div className="page-order">
        <NavigationBar />
        <div id="connection-form-page-div">
          <div
            id="connection-form-panel"
            style={{ padding: "29px 10px 10px 30px" }}
          >
            <div>
              <div>
                <h5 className="page-title" style={{ marginBottom: "40px" }}>
                  Report Definition
                </h5>
              </div>
              <div id="center-div">
                {showErrorMessage ? (
                  <Alert variant="danger">{errorMessage}</Alert>
                ) : null}
                <Form
                  noValidate
                  onSubmit={formik.handleSubmit}
                  id="connection-form"
                >
                  <Form.Row>
                    <Form.Group as={Col} md="6">
                      <Form.Label>Project</Form.Label>
                      {renderProjectBox()}
                      {renderProjectError()}
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} md="6">
                      <Form.Label>Database Connection</Form.Label>
                      {renderConnectionBox()}
                      {renderDatabaseConnectionError()}
                    </Form.Group>
                  </Form.Row>
                  <Form.Row>
                    <Form.Group as={Col} md="6" controlId="validationFormik03">
                      <Form.Label>Definition Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="defName"
                        placeholder=""
                        onChange={formik.handleChange}
                        value={formik.values.defName}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.defName && formik.errors.defName ? (
                        <div
                          style={{
                            fontFamily: "Lexend Deca",
                            fontSize: "12px",
                            color: "#ff0000",
                          }}
                        >
                          {formik.errors.defName}
                        </div>
                      ) : null}
                      {showReportNameErrorMessage ? (
                        <div
                          style={{
                            fontFamily: "Lexend Deca",
                            fontSize: "12px",
                            color: "#ff0000",
                          }}
                        >
                          {reportNameErrorMessage}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Form.Row>
                  {renderTextArea()}
                </Form>
              </div>
            </div>
          </div>
        </div>
        {renderFetchedPreferences()}
      </div>
    </div>
  );
};

export default ConnectionSettingForm;
